<template>
  <div class="root">
    <el-form
      ref="form"
      :model="form"
      label-width="170px"
      :inline="true"
      id="selectForm">
      <div class="title"><span class="t-span">项目查询</span></div>
      <div class="quyuselect">
        <el-form-item label="区域 :">
          <el-select
            v-model="form.pid"
            placeholder="请选择区域"
            required
            :popper-append-to-body="false"
            size="medium">
            <el-option
              v-for="(item, index) in options"
              :key="index"
              :label="item.area_name"
              :value="item.dm"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="类别 :">
          <el-select
            v-model="form.number"
            placeholder="请选择类别"
            required
            :popper-append-to-body="false"
            size="medium">
            <el-option
              v-for="(item, index) in options1"
              :key="index"
              :label="item.classname"
              :value="item.number"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="面积 :">
          <el-select
            v-model="mianji"
            placeholder="请选择面积"
            required
            :popper-append-to-body="false"
            size="medium">
            <el-option label="0 ~ 10亩" value="0"></el-option>
            <el-option label="10 ~ 100亩" value="1"></el-option>
            <el-option label="100 ~ 200亩" value="2"></el-option>
            <el-option label="200 ~ 500亩" value="3"></el-option>
            <el-option label="500亩以上" value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-button
          @click="chaxun"
          type="danger"
          class="search-btn"
          size="medium"
          >开始查询</el-button
        >
      </div>
      <!-- <a class="search" @click="chaxun" >开始查询</a> -->
    </el-form>
    <!-- <router-link :to="{name:'交易项目',query:form}" class="search">开始查询</router-link> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      mianji: '',
      form: {
        pid: '',
        area1: '',
        area2: '',
        number: '',
      },
      // 乡镇数组
      options: [],
      // 项目类型数组
      options1: [],
    }
  },
  created() {
    // 获取乡镇信息
    let url = 'ditudaohang'
    // console.log("乡镇信息");
    // console.log(this.ajax_id(url).data);
    this.options = this.ajax_id(url).data

    // 获取项目类型信息
    let url1 = 'xiangmuleixing'
    console.log('项目类型')
    console.log(this.ajax_id(url1).data)
    this.options1 = this.ajax_id(url1).data
  },
  updated() {
    if (this.mianji == 0) {
      this.form.area1 = 0
      this.form.area2 = 10
    } else if (this.mianji == 1) {
      this.form.area1 = 10
      this.form.area2 = 100
    } else if (this.mianji == 2) {
      this.form.area1 = 100
      this.form.area2 = 200
    } else if (this.mianji == 3) {
      this.form.area1 = 200
      this.form.area2 = 500
    } else if (this.mianji == 4) {
      this.form.area1 = 500
      this.form.area2 = 10000
    }
  },
  mounted() {},
  computed: {},
  watch: {},
  methods: {
    chaxun() {
      console.log(this.form)
      if (this.form.pid && this.form.area2 && this.form.number) {
        this.$router.push({ name: '交易项目', query: this.form })
      } else {
        this.$message({
          message: '请选择查询信息',
          type: 'warning',
        })
      }
    },
  },
}
</script>

<style scoped>
.root {
  width: 100%;
  height: 450px;
  /* line-height: 80px; */
  /* background-color: pink; */
  box-sizing: border-box;
  margin-bottom: 5px;
  /* padding: 0 30px; */
  background: #ffffff;
  box-shadow: 0px 0px 24px 0px rgba(21, 21, 21, 0.1);
  /* overflow: hidden; */
  padding: 10px;
}

.quyuselect {
  -moz-transform: scale(1.3, 1);
  margin-top: 20px;
}

.quyuselect /deep/ .el-select-dropdown__item {
  font-size: 20px !important;
}

.title {
  /* margin-left: 20px; */
  font-size: 37px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #2187ff;
  width: 90%;
  border-bottom: 1px solid #2187ff;
  padding-left: 20px;
  padding-bottom: 10px;
}
.t-span {
  /* border: #2187FF 1px solid; */
  padding: 0 10px;
  border-left: #6681ea 6px solid;
}
.root >>> .el-form--inline .el-form-item__content {
  vertical-align: middle;
}

.search-btn {
  margin-left: 220px;
  position: relative;
  top: -6px;
}

#selectForm >>> .el-form-item__label {
  font-size: 26px;
}
#selectForm >>> .el-input--medium .el-input__inner {
  height: 50px;
  line-height: 50px;
  font-size: 20px;
}
</style>
